import server from '@/request';

export default {
  getDistrictListByPid ({pid, excludeCountry = false}) {
    return server.post('/xiaozi-base/district/getDistrictListByPid', {pid: pid, onlyFindCountryProvinceFlag: excludeCountry});
  },
};
